import React, { useState, useEffect } from 'react';
import { GetCompletionStatus } from '../ApiClient/ApiClient';
import SectionStatus from "./SectionStatus";
import useSession from '../../useSession';
import Grid from "@mui/material/Grid";
import MainNav from '../MainNav/MainNav';
import { GetTermsRead } from '../Helpers/Helpers';

function ParseQs(qsname) {
    let params = (new URL(document.location)).searchParams;
    let qsvalue = "";
    if (params.has(qsname)) {
        qsvalue = params.get(qsname);
    }
    return qsvalue;
} 

export default function Status() {

    const { sessionItem } = useSession();
    const final = sessionItem.film.submittedfinal;
    let changed = sessionItem.film.changed;
     
    let sectionid = 1;
    const qssection = ParseQs("sectionid");
    if (qssection) {
        sectionid = qssection;
    }    

    // For PA this is the main page
    // let's make sure that terms are read
    // if not redirect to agreeterms page
    // we will refactor that page to display a message
    // with no question ask
    const filmid = sessionItem.film.filmObjId;
    const readterms = GetTermsRead(filmid);
    if (!readterms) {
        window.location.href = '/agreeterms';
    } 
          
    const [opMessage, setOpMessage] = useState("");
    const [statusData, setStatusData] = useState();

    // call API hook
    useEffect(() => {  
        let sectionid = 1;
        const qssection = ParseQs("sectionid");
        if (qssection) {
            sectionid = qssection;
        }
        const credentials = sessionItem.accesstoken;
        const filmid = sessionItem.film.filmObjId;
        const formid = sessionItem.form.form_id;
        const getStatusData = async () => {            
            const respo = await GetCompletionStatus(credentials, filmid, formid, sectionid);
            if (respo.film_id && respo.film_title) {
                setStatusData(respo);               
            } else {
                // handle error             
                setOpMessage("Unexpected error while loading the data for this page.")                
            }
        };
        getStatusData();
    }, [sessionItem.accesstoken, sessionItem.film.filmObjId, sessionItem.form.form_id]);
    // end of async call logic

    if (statusData) {
        // pass API response to Section Status Component
        let details = [];
        let completed = false;
        if (statusData.details) {
            details = statusData.details;           
        }
        // generate status message
        if (statusData.completed) {
            completed = true;            
        }
        // update changed property from the completion status data
        if (statusData.changed) {
            changed = true;
        }
        // for PA we display the submit final section in this page
        // we also use the changed property of the filmobj
        // to determine the copy on the submit final action
        let finalcontent = "";
        if (completed) {            
            // display submit final action if completed
            if (changed) {
                finalcontent = <div className="dashboard-final"><a className="lightblue" href="/submitfinal">Proceed to Submit Final Page</a></div>;
            } else {
                finalcontent = <div className="dashboard-final"><a className="lightblue" href="/submitfinal">Proceed to Submit Final Page - No Change</a></div>;
            }            
        }
        // if film is submitted final indicate it in submit final div
        // and remove the link
        if (final) {
            finalcontent = <div className="dashboard-final">This film information has been submitted final. If amendments to the information supplied are required, they must be sent
                directly to the Publicist Registration team at <a class="lightblue" href="mailto:publicistregistration@tiff.net">publicistregistration@tiff.net</a></div>;
        }
        // render SectionStatus Component that displays the completion status of a form section
        return (<div>
                  <div>
                <MainNav />
                <article>
                    <h2>WHY SHOULD YOU CONFIRM YOUR PUBLICISTS?</h2>
                    <ul>
                        <li>
                            We need a contact to provide to the media who are interested in covering your film.
                            The publicist contacts you supply here for each territory will be shared
                            with the TIFF accredited media list. This gives
                            accredited media the correct contacts for your film.
                        </li>
                        <li>
                            We use this information to know what publicists and publicist
                            companies are representing films at the Festival and will need to
                            register for Publicist Passes.
                        </li>
                        <li>
                            If you don't submit this form or we don't have a publicist contact
                            for your film, we will have to send interested media to the
                            Press Office Contact you entered on your Film Registration
                            Form instead.
                        </li>
                    </ul>
                    <p>
                        If you don't have a publicist for your film, please email <a class="lightblue" href="mailto:publicistregistration@tiff.net">publicistregistration@tiff.net</a> to let
                        the team know who the contact for media interest will be.
                    </p>
                    <p>
                        Please review and confirm your film's list of publicist contacts on this form by
                        Monday, August 3, 2026 at 8pm EDT/5pm PDT.
                        Please note: The sooner this information is confirmed,
                        the sooner we will reach out regarding registration for Publicist passes.
                    </p>
                    <p>
                        This form may be updated and saved several times before submitting.
                        <span className="boldtext"> However, once it is submitted it is considered final
                            and you cannot submit changes through the form.</span> At that point,
                        you will need to email publicist contact changes to <a class="lightblue" href="mailto:publicistregistration@tiff.net">publicistregistration@tiff.net</a>.
                    </p>
                    <p>
                        To submit the form, your form must include:
                        <ul>
                            <li>
                                A Press Office Contact (the main contact for TIFF
                                Communications to reach out to regarding media, press,
                                PR-related matters, etc.)
                            </li>
                            <li>
                                At least one Publicist role (Canadian Publicist, US Publicist,
                                International Publicist)
                            </li>
                            <li>
                                One of the Publicist roles must be tagged as the
                                Primary Contact (aka Primary Publicist)
                            </li>
                        </ul>
                        <a className="guidelink" target="_blank" href="/pdf/formhelp.pdf">Click here for a step-by-step guide to filling out and submitting this form.</a>
                    </p>
                    <p>
                        Please note: You must mark one of the publicists as the Primary publicist. You
                        won't be able to submit your completed form without doing this.
                    </p>
                </article>      
                  </div>
                    <SectionStatus details={details} completed={completed} sectionid={sectionid} final={final} />
                    {finalcontent}
                  </div>)
    } 

    return (<Grid container spacing={1} >
                <Grid item xs={12}>
                    {opMessage}
                 </Grid >    
            </Grid>);
}